export const buildSelectClasses = ({ 
  bulmaSize, 
  bulmaColor, 
  bulmaStyle, 
  bulmaState, 
  isMultiple 
}) => {
  const classes = ['select'];
  if (bulmaSize) classes.push(bulmaSize);
  if (bulmaColor) classes.push(bulmaColor);
  if (bulmaStyle) classes.push(bulmaStyle);
  if (bulmaState) classes.push(bulmaState);
  if (isMultiple) classes.push('is-multiple');
  return classes.join(' ');
};

export const buildControlClasses = ({ hasIcon, iconPosition, selectClass }) => {
  const classes = ['control'];
  if (hasIcon && iconPosition === 'left') classes.push('has-icons-left');
  if (selectClass) classes.push(selectClass);
  return classes.join(' ');
};